import React from 'react';
import styled from 'styled-components';

const Input = styled.input`
  border-radius: 0 !important;
  border: none !important;
  box-shadow: none !important;
`;

const InputGroup = ({
  errors,
  children,
  maxLength,
  className,
  label,
  ...props
}) => (
  <div className="field">
    {label && (
      <div className="py-2 has-background-white">
        <label className="px-4 has-text-weight-bold"> {label} </label>
      </div>
    )}

    <div className="control">
      {children || (
        <Input
          className={`input has-text-black is-size-8 px-4
           ${errors ? 'is-danger' : ''}  ${className} `}
          {...props}
          maxLength={maxLength}
        />
      )}
      {errors && <p className="help is-danger">{errors}</p>}
    </div>
  </div>
);

export default InputGroup;
